// Module
var code = "<div class=\"full-screen-title\" v-show=\"fullScreen\"></div>";
// Exports
module.exports = code;